
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  },
})
export default class MappingHeaderSelect extends Vue {
  selectedColumn: string | null = null;
  
  @Prop({ default: '' }) private label: string;

  @Prop({ default: null }) private value: string | null;
  @Watch('value', { immediate: true }) onValueChanged() {
    this.selectedColumn = this.value ? this.value : null;
  }

  get headers() {
    const headers = this.$store.state.importer.excelSheetHeaders;
    // const emptyOption = 
    return this.$store.state.importer.excelSheetHeaders;
  }

  selectColumn(column: string) {
    this.$emit('input', column);
  }

}
